import classnames from 'classnames';
import React from 'react';
import { SVGProps } from './SVGProps';

function AppleIdExternalLoginSVG({ className, ...rest }: SVGProps) {
	return (
		<svg
			viewBox="0 0 24 24"
			className={classnames('roc-icon roc-icon-apple-id-external-login', className)}
			{...rest}
		>
			<path d="M16.499 0c-1.279 0.088-2.775 0.907-3.646 1.974-0.795 0.967-1.449 2.404-1.194 3.801 1.398 0.043 2.842-0.795 3.679-1.88 0.783-1.010 1.375-2.437 1.161-3.895z"></path>
			<path d="M21.555 8.052c-1.229-1.541-2.955-2.434-4.585-2.434-2.152 0-3.063 1.031-4.558 1.031-1.542 0-2.713-1.027-4.575-1.027-1.829 0-3.775 1.117-5.010 3.028-1.735 2.691-1.438 7.75 1.374 12.060 1.007 1.542 2.35 3.276 4.108 3.291 1.565 0.015 2.005-1.003 4.125-1.014 2.119-0.012 2.521 1.027 4.083 1.011 1.76-0.014 3.177-1.935 4.183-3.477 0.722-1.105 0.99-1.662 1.549-2.91-4.069-1.55-4.722-7.336-0.694-9.558z"></path>
		</svg>
	);
}

export default AppleIdExternalLoginSVG;
